import React from 'react';
import DecisionFactorsTemplate from '../decisionFactorsTemplate/DecisionFactorsTemplate';

const pageTitle = 'Pain Avoidance';
const pageSubTitle = 'Pain Avoidance';
const videoKey = 'ZdN2ZvRI-Oo';

const PainAvoidance = () => {

    return (
        <DecisionFactorsTemplate
            pageTitle={pageTitle}
            pageSubTitle={pageSubTitle}
            pageDescription={
                <p>
                    Pain Avoidance reflects how important it is to avoid pain or discomfort during and
                    after treatment. This includes pain from the procedure itself, as well as any
                    lingering soreness or irritation during healing.
                    <br/>
                    For example, Total Knee Replacement
                    often comes with significant post-operative pain, while NSAIDs and Cortisone
                    Injections are typically easier to tolerate. This criterion helps prioritize
                    treatments that match your comfort level and minimize physical discomfort.
                </p>
            }
            videoKey={videoKey}
            pageType="criteria"
        />
    );

};

export default PainAvoidance;